import React from "react";
import styled from "styled-components";
import { Column, Text } from "../../../theme/index";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

function FAQItem({ title, text }) {
  return (
    <Column width="85%" margin="2em 0 2em 2em">
      <Text textalign="left" protitle color="#2b2b2b">
        {title}
      </Text>
      <Text textalign="left" color="#2b2b2b">
        {text}
      </Text>
    </Column>
  );
}

const FAQ = ({ data: { faqs } }) => {
  return (
    <Wrapper>
      {faqs &&
        faqs.map((key, index) => {
          return (
            <FAQItem title={key.title} text={key.faqDescription} key={index} />
          );
        })}
    </Wrapper>
  );
};

export const faqs = gql`
  query faqs {
    faqs {
      id
      slug
      title
      faqDescription
    }
  }
`;

export default graphql(faqs, {
  props: ({ data }) => ({
    data
  })
})(FAQ);



// WEBPACK FOOTER //
// ./src/components/screens/About/components/FAQ.jsx